import { CommonColDef } from '../../../../../shared/datacenter/column-defs';
import { ColDefWithFields } from '../../../../../shared/datacenter/column-type';

import { AddToCartComponent } from './add-to-cart.component';

export class AddToCartColDef<TData = unknown, TValue = unknown> extends CommonColDef<TData, TValue> {
	constructor(params: ColDefWithFields<TData, TValue>) {
		super({
			cellRenderer: AddToCartComponent,
			suppressSizeToFit: true,
			...params
		});
	}
}
